/**
 * ConsumerAgentTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";
import {ConsumerAgent} from "./ConsumerAgent";
import {ConsumerAgentCollection} from "./ConsumerAgentCollection";
import {ConsumerAgentMessageTag} from "./ConsumerAgentMessageTag";

export class ConsumerAgentTag extends TagAbstract {
    public message(): ConsumerAgentMessageTag
    {
        return new ConsumerAgentMessageTag(
            this.httpClient,
            this.parser
        );
    }

    /**
     * Returns a specific agent
     *
     * @returns {Promise<ConsumerAgent>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async get(agentId: string): Promise<ConsumerAgent> {
        const url = this.parser.url('/consumer/agent/$agent_id<[0-9]+|^~>', {
            'agent_id': agentId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerAgent;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Returns a paginated list of agents
     *
     * @returns {Promise<ConsumerAgentCollection>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async getAll(startIndex?: number, count?: number, search?: string): Promise<ConsumerAgentCollection> {
        const url = this.parser.url('/consumer/agent', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'GET',
            headers: {
            },
            params: this.parser.query({
                'startIndex': startIndex,
                'count': count,
                'search': search,
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerAgentCollection;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
